import { THIRD_PARTY_BILLINGS_ACTIONS } from './thirdPartyBillings.types'

/**
 * @param {Array} payload
 * @returns {Object}
 */
export const setThirdPartyBillingsAction = payload => ({
  type: THIRD_PARTY_BILLINGS_ACTIONS.SET_THIRD_PARTY_BILLINGS,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setThirdPartyBillingsStatusAction = payload => ({
  type: THIRD_PARTY_BILLINGS_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setThirdPartyBillingsErrorsAction = payload => ({
  type: THIRD_PARTY_BILLINGS_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearThirdPartyBillingsErrorsAction = () => ({
  type: THIRD_PARTY_BILLINGS_ACTIONS.CLEAR_ERRORS
})
